<template>
<div class="row full-width full-height"
  oncontextmenu="return false"
  @dragenter="listen__x__ondragenter"
  @dragleave="listen__x__ondragleave"
  @dragover="listen__x__ondragover"
  @drop="listen__x__ondrop"
  >
  <div class="full-height">
    <sample-image-list
      :images="sampleImages"
      @jobstart="showLayer"
      @joberror="(param) => listen__x__onfileerror(param)"
      @jobdone="(file) => preprocessingFile(file)"
    />
  </div>
  <div class="column col full-width full-height" style="padding:10px 30px 25px 30px;">
    <div style="flex:0 0 40px">
      <div class="row" style="padding-bottom: 6px;">
        <div class="row text-h6">
          {{title}}
          <q-btn dense flat icon="help_outline" @click="state.dialogHelp = true" size="xs" style="margin:3px 0px 0px 3px;" v-show="isDev"/>
        </div>
        <q-space />
        <div class="row text-caption" style="align-items:center">
          <health-check-widget
            ref="health-check"
            :functionCheck="healthCheckFunction"
            :recognizeName="recognizeName"
          />
        </div>
      </div>
    </div>



    <div style="flex:0 0 15px;" />

    <div class="column bg-white shadow-1 full-width">
      <q-expansion-item icon="camera_alt" :label=cameraLabel class="bg-secondary full-width" default-opened dark expand-icon-class="text-secondary" :disable="checkPermission == false"
        @show="state.dialogCameraCapture.show = true"
        @hide="state.dialogCameraCapture.show = true">
      </q-expansion-item>
    </div>

    <div style="flex:0 0 15px;" />

    <div class="column col bg-white shadow-1 full-width">
      <div class="bg-primary" style="padding:10px 10px;">
        <q-file dark color="white" ref="file" :label=fileLabel v-model="compositionFileData.files" dense accept="image/*,.pdf" @input="preprocessingFile">
          <template v-slot:prepend>
            <q-icon name="attach_file" />
          </template>
        </q-file>
      </div>
      <q-separator />
      <q-toolbar>
        <q-btn-group class="image-tool-btn-group" unelevated dense>
          <q-btn unelevated color="primary" icon="fit_screen" label="창에 맞춤" :disable="frameData1._empty == true" dense no-caps @click="$refs['image-view1'].fitToWindow()" style="padding:0px 5px;" />
          <q-separator vertical />
          <q-btn unelevated color="primary" icon="compare" label="이미지 수정" :disable="frameData1._empty == true" dense no-caps @click="$refs['image-processing-dialog'].open(frameData0)" style="padding:0px 5px;" />
        </q-btn-group>
        <q-space />
        <q-tabs
          v-model="state.tab"
          indicator-color="primary"
          inline-label
          shrink stretch
        >
          <q-tab name="text" icon="list_alt" label="Text" />
          <q-tab name="json" icon="account_tree" label="Json" />
        </q-tabs>
      </q-toolbar>
      <q-separator />
      <div class="row col full-height full-width">
        <div class="row col full-height full-width">
          <image-view
            ref="image-view1"
            :frame-data="frameData1"
            :pred="pred"
            class="col full-height full-width"
            :passive="false"
            :initial-tool-option="state.currentFrameToolOption"
            :messages-upload=messagesUpload
            @onstatechange="listen__image_view__onstatechange" />
        </div>

        <div class="rtab row full-height full-width" :class="{col: state.tab == 'image'}" style="border-left:1px solid rgb(210, 210, 210);overflow:auto;">
          <q-tab-panels class="row col full-height full-width" v-model="state.tab" animated>
            <q-tab-panel class="full-height column" name="text" style="overflow:hidden;" >
              <div class="col" style="overflow:auto;">
                <div class="row" style="align-items:center;"><q-icon name="local_drink" size="sm" class="text-primary" /><div style="font-weight:bold;margin-left:5px;margin-right:8px;">1일 섭취량</div>></div>
                <div v-if="fields1.length == 0" class="text-grey row" style="justify-content:center">-</div>
                <template v-else v-for="(field, index) in fields1">
                  <field-list-item2
                    :texts="field"
                    :key="`field1-${index}`"
                  />
                  <q-separator v-if="index < fields1.length - 1" :key="`sep1-${index}`" />
                </template>

                <div style="height:20px;" />

                <div class="row" style="align-items:center;"><q-icon name="local_fire_department" size="sm"  class="text-primary" /><div style="font-weight:bold;margin-left:5px;margin-right:8px;">열량</div>></div>
                <div v-if="fields2.length == 0" class="text-grey row" style="justify-content:center">-</div>
                <template v-else v-for="(field, index) in fields2">
                  <field-list-item2
                    :texts="field"
                    :key="`field2-${index}`"
                  />
                  <q-separator v-if="index < fields2.length - 1" :key="`sep2-${index}`" />
                </template>

                <div style="height:20px;" />

                <div class="row" style="align-items:center;"><q-icon name="menu_book" size="sm"  class="text-primary" /><div style="font-weight:bold;margin-left:5px;margin-right:8px;">영양정보</div>></div>
                <div v-if="fields3.length == 0" class="text-grey row" style="justify-content:center">-</div>
                <template v-else v-for="(field, index) in fields3">
                  <field-list-item2
                    :texts="field"
                    :key="`field3-${index}`"
                  />
                  <q-separator v-if="index < fields3.length - 1" :key="`sep3-${index}`" />
                </template>
              </div>
            </q-tab-panel>
            <q-tab-panel name="json">
              <json-viewer :value="jsonData" :expand-depth=3 copyable></json-viewer>
            </q-tab-panel>
          </q-tab-panels>
        </div>
      </div>
    </div>
  </div>

  <camera-capture-dialog v-if="state.dialogCameraCapture.show"
     :resolution="state.dialogCameraCapture.resolution"
    @oncapture="listen__dialogCameraCapture__oncapture"
    @onerror="state.dialogCameraCapture.show = false"
    />

  <q-dialog v-model="state.dialogOptions.show">
    <q-card style="width: 300px" class="q-px-sm q-pb-md">
      <q-card-section>
        <div class="text-h6">Image options</div>
      </q-card-section>
      <q-item-label header>Textbox line width</q-item-label>
      <q-item class="row" dense>
        <div class="row" style="align-items:center;flex:0 0 50px;">
          <span>{{ parseInt(state.currentFrameToolOption.lineWidth) }}</span>
        </div>
        <div class="row col" style="align-items:center;justify-content:flex-end">
          <q-slider color="teal" v-model="state.currentFrameToolOption.lineWidth" label :min="1" :max="5" :step="1" />
        </div>
      </q-item>
    </q-card>
  </q-dialog>

  <q-dialog v-model="state.dialogHelp">
    <q-card>
      <q-card-section>
        <div class="text-h6">{{title}}</div>
      </q-card-section>

      <q-card-section class="q-pt-none">
        영양 정보가 인쇄된 제품의 이미지를 입력 받아 영양정보에 관련된 필드 정보를 추출한다.
        KGC(2021)과제를 위해 개발이 진행되었다.
        <ul style="margin:3px">
        <li>필드정보 - [1일 섭취량, 열량, 영양정보(Table)]</li>
        </ul>
      </q-card-section>

      <q-card-section class="q-pt-none">
        <div style="font-size:16px;">&#8226;&nbsp;&nbsp;Project Page</div>
        <a href="https://confluence.selvasai.com:8443/pages/viewpage.action?pageId=148249271">https://confluence.selvasai.com:8443/pages/viewpage.action?pageId=148249271</a>
      </q-card-section>

      <q-card-section class="q-pt-none">
        <div style="font-size:16px;">&#8226;&nbsp;&nbsp;인식 API 관리 담당</div>
        Johan
      </q-card-section>

      <q-card-section class="q-pt-none">
        <div style="font-size:16px;">&#8226;&nbsp;&nbsp;인식 API 주소</div>
        {{getAddress()}}
      </q-card-section>

      <q-card-section class="q-pt-none">
        <div style="font-size:16px;">&#8226;&nbsp;&nbsp;ML model</div>
        <ul style="margin:0">
          <li style="word-break: break-all;"><b>text detector:</b>\\fs\영상지능팀\ocr_selvy-ocr-nutritional-information\resource\model\text_detector\inhouse2_ft.pb <i style="color:red">(2.14 MB)</i></li>
          <li style="word-break: break-all;"><b>text recognizer:</b>\\fs\영상지능팀\ocr_selvy-ocr-nutritional-information\resource\model\text_recognizer\m12__d5__wpra__ma.pb <i style="color:red">(7.64 MB)</i></li>
        </ul>
      </q-card-section>

      <q-card-actions align="right">
        <q-btn flat label="확인" color="primary" v-close-popup />
      </q-card-actions>
    </q-card>
  </q-dialog>

  <q-inner-loading :showing="state.loadingLayer.show">
    <q-spinner-facebook
        color="primary"
        size="2em"
      />
    {{ state.loadingLayer.message }}
  </q-inner-loading>

  <q-inner-loading :showing="compositionDropData.counterDrag > 0">
    <div class="text-h3">드롭하세요.</div>
  </q-inner-loading>

  <image-processing-dialog ref="image-processing-dialog"
    @done="listen__ip_dialog__done"
  />
</div>
</template>


<script>
import compositionDrop from '@/composition/drop.js'
import compositionFile from '@/composition/file.js'

import MixinLayer from '@/mixins/layer.js'

import ImageProcessingDialog from '@/components/ImageProcessingDialog.vue'
import SampleImageList from '@/components/SampleImageList2.vue'
import ImageView from '@/projects/ocr/views/ImageView.vue'
import FieldListItem2 from '@/projects/document/components/FieldListItem2.vue'
import HealthCheckWidget from '@/components/healthCheckWidget.vue'
import CameraCaptureDialog from '@/components/CameraCaptureDialog.vue'

import PARSE from '@/js/parse.js'
import MISC from '@/js/miscellaneous.js'
import DocumentOCR from '@/js/document_ocr.js'
import ETC from '@/js/etc.js'
import UserJS from '@/js/user.js'

import {getCurrentInstance} from '@vue/composition-api'

import _ from 'lodash'

export default {
  setup () {
    const vm = getCurrentInstance()
    if (null == vm ) {
      return {}
    }
    const {compositionFileData, preprocessingImageFile} = compositionFile(vm)
    function preprocessingFile(data) {
      const file = data instanceof File ? data : data.file
      return preprocessingImageFile(file, vm.proxy.listen__x__onfilechange, vm.proxy.listen__x__onfileerror)
    }
    const {compositionDropData, listen__x__ondragenter, listen__x__ondragleave, listen__x__ondragover, listen__x__ondrop} = compositionDrop(preprocessingFile)
    return {
      compositionDropData,
      listen__x__ondragenter,
      listen__x__ondragleave,
      listen__x__ondragover,
      listen__x__ondrop,
      compositionDrop,
      compositionFileData,
      preprocessingFile
    }
  },
  mixins: [MixinLayer],
  data: function () {
    return {
      state: {
        dialogHelp: false,
        dialogOptions: {
          show: false
        },
        dialogCameraCapture: {
          show: false,
          resolution: 'vga'
        },
        fitToWindow: false,
        searchText: null,
        tab: 'text',
        currentFrameState: {
          coord: {
            x: 0,
            y: 0
          },
          zoom: undefined,
          voi: {
            windowCenter: 127,
            windowWidth: 256
          }
        },
        currentFrameToolOption: { mouseButtonMask: 2, lineWidth: 2},
        bboxShow: true
      },
      sampleImages: [
        {
          name: '63494_0',
          url: 'https://live.staticflickr.com/65535/51690903935_c2d9153038_o_d.jpg'
        },
        {
          name: '61409_0',
          url: 'https://live.staticflickr.com/65535/51689218982_abbf814d00_o_d.jpg'
        },
        {
          name: '0908_008',
          url: 'https://live.staticflickr.com/65535/51690275608_58728b6e02_o_d.jpg'
        },
        {
          name: '0907_013_02',
          url: 'https://live.staticflickr.com/65535/51690688034_bc46830536_o_d.jpg'
        },
        {
          name: '0907_006____2',
          url: 'https://live.staticflickr.com/65535/51689217702_f4604dfb48_o_d.jpg'
        },
        {
          name: '0906_026_02',
          url: 'https://live.staticflickr.com/65535/51690687299_792e77c0e7_o_d.jpg'
        },
        {
          name: '0903_009',
          url: 'https://live.staticflickr.com/65535/51690901215_a446a5810a_o_d.jpg'
        },
        {
          name: '0902_001',
          url: 'https://live.staticflickr.com/65535/51690686349_4d8045fdc7_o_d.png'
        }
      ],
      fieldInfo: [],
      frameData1: {
        _uid: MISC.getUuid4(),
        _empty: true
      },
      frameData2: {
        _uid: MISC.getUuid4(),
        _empty: true
      },
      pred: [],
      fields: [],
      fields1: [],
      fields2: [],
      fields3: [],
      jsonData: [],
      title: "영양기능정보",
      recognizeName: "ni"
    }
  },
  components: {
    ImageProcessingDialog,
    SampleImageList,
    ImageView,
    FieldListItem2,
    HealthCheckWidget,
    CameraCaptureDialog
  },
  methods: {
    listen__x__onfilechange: function (file, options) {
      const Vue = this
      
      const keepFrameData0 = (options != undefined && options.keepFrameData0 == true) ? true : false
      Vue.clearData(keepFrameData0)
      Vue.showLayer('이미지를 읽는 중...');
      
      MISC.doubleRaf(async () => {
        let image;
        
        let tokens = file.name.split('.');
        let ext = tokens[tokens.length - 1].toLowerCase();
        try {
          image = await PARSE.parseImage(file, ext);
        } catch (err) {
          console.log(err)
          Vue.listen__x__onfileerror({color: 'purple', message: '이미지 읽기에 실패하였습니다'})
          return
        }
        let cornerstoneImage = await Vue.$cornerstone.createCornerstoneImageRgba(undefined, image.pixelData, image.width, image.height);

        Vue.showLayer('인식 중...');
        let ret = {};
        let processingTime
        try {
          const begin = new Date();
          ret = await DocumentOCR.recognizeNutritionalInformation(file);
          processingTime = (new Date() - begin) / 1000

          let fields1 = []
          if (ret.data['1일섭취량'] != undefined && ret.data['1일섭취량'].length > 0) {
            const text = ret.data['1일섭취량'].join(' ')
            if (text.length > 0)
              fields1.push([text])
          }

          let fields2 = []
          if (ret.data['열량'] != undefined && ret.data['열량'].length > 0) {
            fields2.push([ret.data['열량']])
          }

          let fields3 = []
          if (ret.data['영양성분'] != undefined) {
            for (let row of ret.data['영양성분']) {
              fields3.push([
                row['성분명'] != undefined ? row['성분명'] : '-',
                row['함량'] != undefined ? row['함량'] : '-',
                row['영양성분기준치'] != undefined ? row['영양성분기준치'] : '-'
              ])
            }
          }

          ret.pred = []
          ret.fields = []
          ret.fields1 = fields1
          ret.fields2 = fields2
          ret.fields3 = fields3
        } catch (err) {
          console.log(err)
          Vue.listen__x__onfileerror({color: 'red', message: err})
          return
        }
        if (keepFrameData0 == true) {
          Vue.frameData1 = {
            id: MISC.getUuid4(),
            name: file.name,
            cornerstoneImage,
            _empty: false
          }
        } else {
          Vue.frameData0 = {
            id: MISC.getUuid4(),
            name: file.name,
            cornerstoneImage,
            _empty: false
          }
          Vue.frameData1 = Vue.frameData0
        }
        Vue.pred = ret.pred
        Vue.fields = ret.fields
        Vue.fields1 = ret.fields1
        Vue.fields2 = ret.fields2
        Vue.fields3 = ret.fields3
        ret.data['processingTime'] = processingTime
        Vue.jsonData = ret.data;
        Vue.hidingLayer()
      });
    },
    listen__x__onfileerror: function (param) {
      const Vue = this

      Vue.jsonData = []
      Vue.compositionFileData.files = []
      Vue.clearData()
      Vue.hidingLayer()

      let color = param.color
      if (color == undefined)
        color = 'black'

      Vue.$q.notify({
        message: param.message,
        icon: 'announcement',
        color
      })
    },
    listen__image_view__onstatechange: function (data) {
      if (data.coord != undefined)
        this.state.currentFrameState.coord = {x: data.coord.x, y: data.coord.y}
      if (data.zoom != undefined)
        this.state.currentFrameState.zoom = data.zoom
      if (data.voi != undefined)
        this.state.currentFrameState.voi = {windowCenter: data.voi.windowCenter, windowWidth: data.voi.windowWidth}
      const imageView2 = this.$refs['image-view2']
      if (imageView2 != undefined) {
        imageView2.tostatechange(data)
      }
    },
    listen__btn_bbox__onclick: function () {
      this.state.bboxShow = !this.state.bboxShow;
      
      this.updateTagging()
    },
    listen__dialogCameraCapture__oncapture: function (data) {
      this.state.dialogCameraCapture.resolution = data.resolution
      this.state.dialogCameraCapture.show = false
      if (data.file != undefined) {
        this.listen__x__onfilechange(data.file)
      }
    },
    listen__text_search__oninput: _.debounce(function (e) {
      this.state.searchText = e.target.value
    }, 300),
    listen__ip_dialog__done: async function (data) {
      const Vue = this
      if (Vue.frameData1.id != data.id) {
        Vue.listen__x__onfilechange(
          PARSE.encodeImage(Vue.frameData1.name, data.cornerstoneImage.getPixelData(), data.cornerstoneImage.width, data.cornerstoneImage.height),
          {keepFrameData0: true}
        )
      }
    },
    clearData: function (keepFrameData0) {
      if (keepFrameData0 == false) {
        this.frameData0 = {
          _uid: MISC.getUuid4(),
          _empty: true
        }
      }
      this.frameData1 = {
        _uid: MISC.getUuid4(),
        _empty: true
      }
      this.frameData2 = {
        _uid: MISC.getUuid4(),
        _empty: true
      }
      this.pred = []
      this.fields = []
      this.fields1 = []
      this.fields2 = []
      this.fields3 = []
    },
    updateTagging() {
      for (let item of this.pred) {
        const idx = this.searchTexts.findIndex((v) => item.id == v.id);
        if (idx != -1) {
          for (let row of this.pred) {
            if (row.id == item.id)
              row['active'] = this.state.bboxShow
          }
        } else {
          for (let row of this.pred) {
            if (row.id == item.id)
              row['active'] = false
          }
        }
      }

      this.$refs['image-view1'].updateTagging()
      if (this.$refs['image-view2'] != undefined)
        this.$refs['image-view2'].updateTagging()
    },
    healthCheckFunction: DocumentOCR.recognizeNutritionalInformation,
    getAddress: function () {
      const Vue = this
      return Vue.$refs['health-check'] == undefined ? '' : Vue.$refs['health-check'].getAddress()
    }
  },
  computed: {
    searchTexts: function () {
      if (this.pred.length == 0)
        return [];
      if (this.state.searchText == null || this.state.searchText.length == 0) {
        return this.pred.slice();
      } else {
        let searchTexts = [];
        for (let item of this.pred) {
          if (item.key.indexOf(this.state.searchText) != -1)
            searchTexts.push(item);
        }
        return searchTexts;
      }
    },
    searchFields: function () {
      let searchFields = [];
      for (let item of this.fields) {
        const idx = this.searchTexts.findIndex((v) => item.id == v.id);
        if (idx != -1)
          searchFields.push(item);
      }
      return searchFields;
    },
    checkPermission() {
      const Vue = this
      if (ETC.isDev())
        return true
      if (undefined != Vue.recognizeName)
        return UserJS.checkPermission(Vue.$store.state.user.permission, Vue.recognizeName)
      return true
    },
    isDev() {
      return ETC.isDev()
    },
    messagesUpload() {
      if (this.checkPermission)
        return ['\'샘플 이미지\'를 선택,', '\'파일 업로드...\'를 클릭,', '또는 이미지를 여기로 \'드래그\' 하여', '인식을 시작합니다.']
      return ['\'샘플 이미지\'를 선택 하세요.']
    },
    fileLabel() {
      if (this.checkPermission)
        return '파일 업로드...'
      return '파일 업로드 권한이 없습니다.' 
    },
    cameraLabel() {
      if (this.checkPermission)
        return '카메라 열기'
      return '카메라 권한이 없습니다.' 
    }
  },
  watch: {
    searchTexts: function () {
      this.updateTagging()
    },
    'state.currentFrameToolOption.lineWidth': function (value) {
      this.$refs['image-view1'].setToolOption('lineWidth', value)
      if (this.$refs['image-view2'] != undefined)
        this.$refs['image-view2'].setToolOption('lineWidth', value)
    }
  },
  async mounted () {
    const Vue = this
    Vue.$refs['health-check'].listen__healthcheck__onclick()
  }
}
</script>

<style scoped>
.rtab:not(.col) {
  flex: 0 0 400px;
}

@media (max-width: 1000px) {
  .image-tool-btn-group {
    display: none !important;
  }
}
</style>